import { render, staticRenderFns } from "./problem-renderer-body.vue?vue&type=template&id=d22211b2&scoped=true&"
import script from "./problem-renderer-body.component.ts?vue&type=script&lang=js&"
export * from "./problem-renderer-body.component.ts?vue&type=script&lang=js&"
import style0 from "./problem-renderer-body.vue?vue&type=style&index=0&id=d22211b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22211b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/3/gateway/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d22211b2')) {
      api.createRecord('d22211b2', component.options)
    } else {
      api.reload('d22211b2', component.options)
    }
    module.hot.accept("./problem-renderer-body.vue?vue&type=template&id=d22211b2&scoped=true&", function () {
      api.rerender('d22211b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/shared/problem-renderer/problem-renderer-body.vue"
export default component.exports